export default "__VITE_ASSET__D3CFIQly__"